import getCommonTestId from 'constants/testsIds/common';
import { Title } from 'components/Company/ArticleCard/ArticleCardStyles';
import { NextCustomImage as NextImage } from 'components/Image';
import { ARTICLE_CARD_TEST_IDS } from 'constants/testsIds/articleComponents';
import type { PinnedArticle } from 'interfaces/content/articles/Articles';
import * as S from './PinnedArticleStyles';

export interface PinnedArticleCardProps {
  article: PinnedArticle;
  className?: string;
  key?: string;
}

const PinnedArticleCard = ({ article, className, key }: PinnedArticleCardProps) => (
  <S.PinnedArticleWrapper
    key={key}
    className={className}
    href={article.titleLink}
    data-cy={getCommonTestId('PINNED_ARTICLE_CARD')}
    type='brandAccentPrimary'
  >
    {!!article.image?.mediaItemUrl && (
      <S.PinnedCardImage $variant='card-md'>
        <NextImage
          width={140}
          height={90}
          src={article.image?.mediaItemUrl}
          alt={article.image?.altText ? article.image?.altText : article.title}
          data-cy={ARTICLE_CARD_TEST_IDS.IMAGE}
        />
      </S.PinnedCardImage>
    )}
    <S.PinnedCardBody>
      <Title
        as='h3'
        className='no-hover no-focus'
        $fontFamily='graphikCond'
        $size={{ default: 'level7', lgMin: 'level6', xlMin: 'level5' }}
      >
        {article.title}
      </Title>
      {article.dateUpdatedGMTFormatted && (
        <span
          className='card-date'
          data-cy={ARTICLE_CARD_TEST_IDS.DATE}
        >
          {article.dateUpdatedGMTFormatted}
        </span>
      )}
    </S.PinnedCardBody>
  </S.PinnedArticleWrapper>
);

export default PinnedArticleCard;
